import { z } from 'zod'

export const schema = z.object({
  input_type: z.union([z.literal('banks'), z.literal('custodians')]),
  report_date: z.string().date(),
})

export type SchemaType = z.infer<typeof schema>
